<template>
    <section>
        <div class="container mt-8 pl-6 pr-6 lg1024:pl-0 lg1024:pr-0">
            <router-link to="/" class="flex flex-col logo-container">
                <h1 class="uppercase font-bebas text-5xl">{{ nameHeader }}</h1>
<!--                <p class="text-sm logo-subtitle">{{getLogoTitle()}}</p>-->
            </router-link>
            <NavigationMenuTop />
        </div>
    </section>

</template>

<script>
  import NavigationMenuTop from "./NavigationMenuTop.vue";
export default {
  name: 'Header',
  components: {
    NavigationMenuTop,
  },
  computed: {
    nameHeader() {
      const header = this.$store.getters.getHeaderFocus

      if (header && header !== 'none') {
        return header
      }

      const match = location.pathname.match(/\/news\/([^/]+)/)
      let text

      if (match) {
        text = this.$store.getters.getTranslation(match[1])
      } else {
        text = this.$store.getters.getTranslation('main')
      }

      return text || 'Coral News'
    }
  },
  methods: {
    getLogoTitle() {
      return this.$store.getters.getTranslation("logo_title");
    }
  }
}
</script>

<style scoped>
.logo-container {
    width: fit-content;
}
.logo-subtitle {
    margin-top: -.5em;
    margin-left: 0.2em;
    line-height: 1 !important;
}
</style>
